import View from './view';
export const FooterGroup = View;
